import React from 'react';
import { Link } from 'react-router-dom';

export default function Otherfilings() {
  return (
    <div>
      {/* Header Start */}
      <div className="container-fluid hero-header bg-light py5 mb5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-12">
              <h1 className="display-4 mb-3 animated slideInDown">
                Other Filings with stock exchange
              </h1>
              <nav aria-label="breadcrumb" className="animated slideInDown">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                  <li className="breadcrumb-item"><Link to="/investor-relation">Investor Relation</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Other Filings with stock exchange
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* Header End */}

      {/* About Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="table-responsive table_heading">
				<table className="table table-bordered table-striped">
				  <thead>
					<tr> 
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2026-27</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>  
					<tr>
					  <td>Compliances Certificate under Reg 74 (5) of SEBI(DP) Regulations 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Compliances-Certificate-under-Reg74(5)-ofSEBI-(DP)-Regulations-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Compliance certificate Under Regultion 76 of SEBI (DP) Regulation, 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Compliance-certificate-Under-Regultion76of-SEBI-(DP)-Regulation-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Closure of Trading Window</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Closure-of-Trading-Window.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>				  
					<tr>
					  <td>Appointment of Internal Auditor for FY 2026-27</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Appointment-of-Internal-Auditor-for-FY-2026-27.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Annual Disclosure Reg 31 (4) SAST</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Annual-Disclosure-Reg-31-(4)-SAST.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Compliance certificate Under Regultion 76 of SEBI (DP) Regulation, 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Compliance-certificate-Under-Regultion-76-of-SEBI-(DP)-Regulation-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Regulation 74(5) of the SEBI (Depositories and Participants) Regulations, 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Regulation-74(5)-of-the-SEBI-(Depositories-and-Participants)-Regulations-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Initial Disclosure By Large Entity</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2026-27/Initial-disclosure-by-large-entity.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					 <td>Closure of Trading Window (Quarter and half year ended 30th September, 2026)</td>
					 <td width={280} className="text-center">
					  <Link to="/stock-exchnage/2026-27/Closure of Trading Window.pdf" target="_blank">
						Download
					  </Link>{" "}
					 </td>
					</tr>
				  </tbody>
				</table>
			  </div>
			  
			  
			  
			  <div className="table-responsive table_heading">
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2025-26</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>    
					<tr>
					  <td>Closure of Trading Window</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Closure-of-Trading-Window-2026.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Compliance certificate Under Regultion 76 of SEBI (DP) Regulation, 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Compliance-certificate-Under-Regultion76-of-SEBI-(DP)-Regulation-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Regulation 74(5) of the SEBI (Depositories and Participants) Regulations, 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Regulation-74(5)-of-the-SEBI-(Depositories-and-Participants)-Regulations-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Closure of Trading Window</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Closure-of-Trading-Window-2025-26.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Compliance certificate Under Regultion 74(5) of SEBI (DP) Regulation, 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Compliance-certificate-Under-Regultion-74(5)-of-SEBI-(DP)-Regulation-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Compliance certificate Under Regultion 76 of SEBI (DP) Regulation, 2018</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Compliance-certificate-Under-Regultion-76-of-SEBI-(DP)-Regulation-2018.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Closure of Trading Window</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Closure-of-Trading-Window.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Book Closure Date</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Book-Closure-Date.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>TRADING WINDOW</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/TRADING-WINDOW.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					<tr>
					  <td>Reply to Discrepancy</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Reply-to-Discrepancy.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					<tr>
					  <td>Large Entity</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Large-Entity.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					
					
				   <tr>
					  <td>Reg 74(5)_07.07.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Reg74(5)_07.07.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					 <tr>
					  <td>Reg-74(5)_04.04.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2025-26/Reg-74(5).pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
				  </tbody>
				</table>
			  </div>
			  
			  <div className="table-responsive table_heading">
				<table className="table table-bordered table-striped">
				  <thead>
					<tr>
					  {/*<th width="20" class="text-center">No.</th>*/}
					  <th className="text-left">2024-25</th>
					  <th>Download Link</th>
					</tr>
				  </thead>
				  <tbody>
					
					<tr>
					  <td>Large Entities disc_2025</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/LargeEntitiesdisc-2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					<tr>
					  <td>Reg 7(3)_2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Reg7(3)_2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
					<tr>
					  <td>Reg 40(9)_30.04.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Reg40(9)_30.04.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Reg 47(5) DP_15.04.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Reg47(5)DP_15.04.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Reg 47(5) DP_15.10.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Reg47(5)DP_15.10.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Reg 74(5) DP_15.10.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Reg74(5)DP_15.10.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Reg74(5) DP_06.01.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Reg74(5)DP_06.01.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Revised FR-September- 2023</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Revised-FR-September-2023.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Trading Window_02.07.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Trading-Window-02.07.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Trading Window_20.06.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Trading-Window-20.06.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Trading Window_20.12.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Trading-Window-20.12.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Trading Window_26.09.2024</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Trading-Window-26.09.2024.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr><tr>
					  <td>Trading Window_27.03.2025</td>
					  <td width={280} className="text-center">
					   <Link to="/stock-exchnage/2024-25/Trading-Window-27.03.2025.pdf" target="_blank">
						Download
					   </Link>{" "}
					  </td>
					</tr>
					
				  </tbody>
				</table>
			  </div>
          </div>
        </div>
      </div>
      {/* About End */}
    </div>
  );
}
